<template>
  <div>
     <div class="app-content content" style="margin: 0; padding: 30px;">
        <div class="content-overlay"></div>
        <div class="header-navbar-shadow"></div>
        <div class="content-wrapper">
            <div class="content-header row">
            </div>
            <div class="content-body">
                <div class="auth-wrapper auth-cover">
                    <div class="auth-inner row m-0">
                        <div class="d-none d-lg-flex col-lg-6 align-items-center p-5">
                            <div class="w-100 d-lg-flex align-items-center justify-content-center px-5"><img class="img-fluid" src="app-assets/images/pages/forgot-password-v2.svg" alt="Forgot password V2" /></div>
                        </div>
                        <!-- /Left Text-->
                        <!-- Forgot password-->
                        <div class="d-flex col-lg-6 align-items-center auth-bg px-2 p-lg-5">
                            <div class="col-12 col-sm-8 col-md-6 col-lg-12 px-xl-2 mx-auto">
                              <div style="margin-left: -15px;">
                                  <a class="nav-link py-lg-2" href="/">
                                      <img src="app-assets/images/brand-logo.png" style="height: 45px;">
                                   </a>
                                </div>
                                <h2 class="card-title fw-bold mb-1">Forgot Password? 🔒</h2>
                                <p class="card-text mb-2">Enter your email and we'll send you instructions to reset your password</p>
                                <form class="auth-forgot-password-form mt-2" action="auth-reset-password-cover.html" method="POST" @submit.prevent="forgetPassword()">
                                    <div class="mb-1">
                                        <label class="form-label" for="forgot-password-email">Email</label>
                                        <input class="form-control" id="forgot-password-email" v-model="formData.email" type="text" name="forgot-password-email" placeholder="Email (as user id)" aria-describedby="forgot-password-email" autofocus="" tabindex="1" />
                                    </div>
                                    <button v-if="!loading" class="btn btn-primary w-100" tabindex="2">Send reset link</button>
                                    <button v-else disabled class="btn btn-primary w-100" tabindex="2">
                                      <span class="spinner-border spinner-border-sm text-white" role="status" aria-hidden="true"></span>
                                      Send reset link
                                    </button>
                                </form>
                                <p class="text-center mt-2"><router-link to="/login"><i data-feather="chevron-left"></i> Back to login</router-link></p>
                            </div>
                        </div>
                        <!-- /Forgot password-->
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script setup>
import { ref, inject } from 'vue'
import { useRouter } from 'vue-router'
import handleForgetPassword from '@/services/modules/forgetPassword'

const { loading, setForgetPassword } = handleForgetPassword()

const router = useRouter()
const showError = inject('showError')
const showSuccess = inject('showSuccess')

const formData = ref({
  email: null,
})

const forgetPassword = async () => {
  loading.value = true
  try {
    const res = await setForgetPassword(formData.value)
    if (!res.status) {
      showError(res.message)
      return
    }
    showSuccess(res.message)
    setTimeout(() => {
      router.push({ name: 'Login' })
    }, 1000)
  } catch (err) {
    if (!err.response) {
      showError('Something is wrong. Check your connectivity!!')
      return
    }
    showError(err.response.message)
  } finally {
    loading.value = false
  }
}
</script>

<style scoped>
  .contnet{
    margin: 0 !important;
  }
</style>
